import { Component, OnInit } from '@angular/core';
import {Location} from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { UserSessionService } from '../../UserSession/user-session.service';
import { NbToastrService } from '@nebular/theme';
import { LocalDataSource } from 'ng2-smart-table';
import { SystemService } from '../../apiclient';
import * as moment from 'moment';

/**
 * @ignore
 */
@Component({
  selector: 'ngx-company-entities-list',
  templateUrl: './company-entities-list.component.html',
  styleUrls: ['./company-entities-list.component.scss']
})
export class CompanyEntitiesListComponent implements OnInit {

  loading = false;
  tituloEntidad: string;
  tipoEntidad: string;
  entitiesToRemove = [];
  iconos = {
    disease :'bug',
    maintenance: 'toolbox',
    machinery:'tractor',
    product:'pump-medical',
    field:'draw-polygon',
  };

  parcelasettings = {
    attr:{
      id:'tabla-parcelas',
    },
    actions: {
      delete: false,
      add: true,
      edit:true,
      position: 'right',
  },

    add: {
      addButtonContent: '<i class="eva eva-plus-outline"></i><span>Nuevo</span>',
      createButtonContent: '<i class="eva eva-checkmark-outline"></i>',
      cancelButtonContent: '<i class="eva eva-close-outline"></i>',
    },
    edit: {
      editButtonContent: '<i class="far fa-edit"></i>',
      saveButtonContent: '<i class="eva eva-checkmark-outline"></i>',
      cancelButtonContent: '<i class="eva eva-close-outline"></i>',
    },
    pager:{
      display:false,
    },
    mode:'external',
    columns: {
      name :{
        title: 'Nombre',
        type: 'string',
      },
      region: {
        title: 'Región/Productor',
        type: 'string',
      }
    }
  }
  entitysettings = {
    attr:{
      id:'tabla-entidades',
    },
    actions: {
      delete: true,
      add: true,
      edit:true,
      position: 'right',
  },

    add: {
      addButtonContent: '<i class="eva eva-plus-outline"></i><span>Nuevo</span>',
      createButtonContent: '<i class="eva eva-checkmark-outline"></i>',
      cancelButtonContent: '<i class="eva eva-close-outline"></i>',
    },
    edit: {
      editButtonContent: '<i class="far fa-edit"></i>',
      saveButtonContent: '<i class="eva eva-checkmark-outline"></i>',
      cancelButtonContent: '<i class="eva eva-close-outline"></i>',
    },
    delete: {
      deleteButtonContent: '<i class="eva eva-trash-2-outline"></i>',
      confirmDelete: true,
    },
    pager:{
      display:false,
    },

    columns: {
      name :{
        title: 'Nombre',
        type: 'string',
      }
    }
  }
  source: LocalDataSource = new LocalDataSource();

  constructor(private route: ActivatedRoute,
    private userSessionService: UserSessionService,
    private systemService: SystemService,
    private location: Location,
    private router: Router,
    private nbToastrService: NbToastrService) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.tipoEntidad = params.get('entidad');



          this.configurarEntidad();


      });



  }

  configurarEntidad(): void {

    switch(this.tipoEntidad){
      case 'disease':
        this.tituloEntidad = 'Plagas/Enfermedades';
        this.userSessionService.getCachedDiseaseList().subscribe((diseases) => {
          this.source.load(diseases.sort((a,b)=>a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1));
        })
      break;

      case 'maintenance':
        this.tituloEntidad = 'Mantenimientos';
        this.userSessionService.getCachedMaintenanceList().subscribe((diseases) => {
          this.source.load(diseases.sort((a,b)=>a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1));
        })
      break;

      case 'product':
        this.tituloEntidad = 'Productos Fitosanitarios';
        this.userSessionService.getCachedProductList().subscribe((diseases) => {
          this.source.load(diseases.sort((a,b)=>a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1));
        })
      break;

      case 'machinery':
        this.tituloEntidad = 'Maquinaria';
        this.userSessionService.getCachedMachineryList().subscribe((diseases) => {
          this.source.load(diseases.sort((a,b)=>a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1));
        })
      break;

      case 'field':
        this.tituloEntidad = 'Parcelas';
        this.userSessionService.getCachedFieldList().subscribe((fields) => {
          console.log("CARGAMOS PARCELAS")
          console.log(fields)
          this.source.load(fields.sort((a,b)=>a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1));
        })
      break;



    }

  }
  back(): void{
    this.location.back()
  }

  guardar(): void{
    this.loading = true;
    this.source.getAll().then((entidades) => {

      this.entitiesToRemove.map((entidad) => {
        entidad.disabledAt = Date();
        return entidad;
      })
      entidades = entidades.concat(this.entitiesToRemove);
      console.log(entidades);
      var entities = {};
      entities[this.tipoEntidad+'list'] = entidades;
      this.systemService.uploadOwnEntities(
        entities,
        this.userSessionService.accessToken).subscribe((exito) =>{
          this.loading = false;
          this.nbToastrService.success('Guardado con éxito','Guardar')
          this.source.empty();

          this.userSessionService.removeCachedEntitiesList();
          this.configurarEntidad();
          console.log(exito);

        })
    })
  }

  deleteEntidad(evento): void{
    console.log(evento.data);
    this.entitiesToRemove.push(evento.data);
    evento.confirm.resolve();
    console.log(this.entitiesToRemove);
  }

  editarParcela(evento): void{
    let idParcela = 0;
      if(typeof evento.data != 'undefined'){
        idParcela = evento.data.id;
      }

      this.router.navigate(['pages/parcela',idParcela]);
  }
}
